import React, { useState, useRef, useEffect } from 'react';
import './LegalPages.css';
import './AccessibilityForm.css';
// Note: To use reCAPTCHA, install: npm install react-google-recaptcha
// Then uncomment the import below and add your site key
// import ReCAPTCHA from "react-google-recaptcha";

// Add your reCAPTCHA site key here (get it from https://www.google.com/recaptcha/admin)
const RECAPTCHA_SITE_KEY = 'YOUR_RECAPTCHA_SITE_KEY_HERE';

function Accessibility() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    phone: '',
    email: '',
    description: '',
    url: '',
  });
  const recaptchaRef = useRef();

  const [submitMessage, setSubmitMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.description.trim()) {
      setSubmitMessage('Please describe the usability challenge.');
      return;
    }
    if (!formData.url.trim()) {
      setSubmitMessage('Please provide the webpage URL.');
      return;
    }

    // TODO: Implement reCAPTCHA verification
    // Uncomment when reCAPTCHA is set up:
    // const recaptchaToken = await recaptchaRef.current.executeAsync();
    // if (!recaptchaToken) {
    //   setSubmitMessage('Please verify that you are not a robot.');
    //   return;
    // }

    setIsSubmitting(true);
    
    try {
      // TODO: Replace with actual backend endpoint
      // const response = await fetch('/api/accessibility/report', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     ...formData,
      //     recaptchaToken: recaptchaToken, // Will add when implemented
      //   }),
      // });
      
      // if (response.ok) {
      //   setSubmitMessage('Thank you! Your accessibility feedback has been submitted.');
      //   setFormData({
      //     phone: '',
      //     email: '',
      //     description: '',
      //     url: '',
      //   });
      // } else {
      //   setSubmitMessage('Error submitting form. Please try again.');
      // }

      // For now, show success message
      setSubmitMessage('Thank you! Your accessibility feedback has been submitted.');
      setFormData({
        phone: '',
        email: '',
        description: '',
        url: '',
      });
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitMessage('Error submitting form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Accessibility</h1>
      </div>
      
      <div className="legal-subheader">
        Last Updated: February 18, 2026
      </div>
      
      <div className="legal-container">
        <section className="legal-section">
          <h2>Website access</h2>
          <p>
            We strive to make our products and services, and all of our web content, accessible to all customers. We care about the customer experience of everyone, regardless of disabilities. To accomplish this, we take steps to improve Tytonvoice.ai, improve functionality with assertive technology devices, and ensure consistency with the World Wide Web Consortium's Content Accessibility Guidelines (WGAG 2.0). Tytonvoice is a Think A Move (TAM) technology. Our team employs accessibility and usability tests during regular content reviews to improve the accessibility of our site.
            <br/><br/>
            For those who are vision impaired we have implemented an additional functionality of a High Contrast Mod. You can access that using the link in the footer of any page on Tytonvoice.ai.
            <br/><br/>
            In addition, we encourage customers and anyone else who visits our website to let us know if there are any problems with accessing any portion of the site. To share your feedback specific to Accessibility suggestions please use the form below. Thanks for your interest in Tytonvoice.ai.
          </p>
        </section>
          
          <form className="accessibility-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="(123) 456-7890"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">
                Please describe the usability challenge that you have encountered <span className="required">*</span>
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Describe the accessibility issue..."
                rows="5"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="url">
                Please give us the URL for the webpage with the reported problem <span className="required">*</span>
              </label>
              <input
                type="url"
                id="url"
                name="url"
                value={formData.url}
                onChange={handleChange}
                placeholder="https://www.tytonvoice.ai/page"
                required
              />
            </div>

            <div className="form-group">
              <label>reCAPTCHA Verification</label>
              {/* 
                TODO: Uncomment when reCAPTCHA is set up
                Prerequisites:
                1. Install package: npm install react-google-recaptcha
                2. Add your reCAPTCHA site key to RECAPTCHA_SITE_KEY above
                3. Uncomment the import at the top of this file
                
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={(token) => {
                    // Token is automatically handled in handleSubmit
                  }}
                />
              */}
              <p className="recaptcha-note">
                reCAPTCHA verification will be enabled soon.
              </p>
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Accessibility Report'}
            </button>
            
            {submitMessage && (
              <div className={`submit-message ${submitMessage.includes('Thank you') ? 'success' : 'error'}`}>
                {submitMessage}
              </div>
            )}
          </form>
      </div>
    </div>
  );
}

export default Accessibility;
